var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"global-button-vuetify",attrs:{"icon":""},on:{"click":_vm.refresh}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":"#92278e"}},[_vm._v("mdi-autorenew")])],1)]}}])},[_vm._v("Refresh diagrams")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }